<div class="single-day-stack">
  <div class="div-aside">
    <div class="day-block">
      <h5>{{hour.Day}}</h5>
    </div>
    <div class="switch-block">
      <div class="switch-stack">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="sunSwitch" (change)="ChangeSelection(hour)"
            [checked]="hour.isOpen">
          <label class="form-check-label" *ngIf="!hour.isOpen" for="sunSwitch">Closed</label>
          <label class="form-check-label" *ngIf="hour.isOpen" for="sunSwitch">Open</label>
        </div>
      </div>
    </div>
  </div>
  <div class="timepicker-block">
    <div class="inner-stack">
      <!-- <input aria-label="default time" [ngxTimepicker]="timeSunstart" [(ngModel)]="hour.From"
              class="form-control" [disabled]="!hour.isOpen">
          <ngx-material-timepicker #timeSunstart></ngx-material-timepicker>
          <p>To</p>
          <input aria-label="default time" [min]="hour.From"  [ngxTimepicker]="timeSunend" [(ngModel)]="hour.To"
              class="form-control" [disabled]="!hour.isOpen">
          <ngx-material-timepicker #timeSunend></ngx-material-timepicker> -->
      <ng-select [disabled]="!hour.isOpen" [(ngModel)]="hour.From" (change)="onFromTimeSelect()"
        class="ng-form-select primary-select">
        <ng-option *ngFor="let type of timeforFirstSelector" [value]="type">{{type}}</ng-option>
      </ng-select>
      <p>To</p>
      <ng-select [disabled]="!hour.isOpen" [(ngModel)]="hour.To" (change)="onToTimeSelect()"
        class="ng-form-select primary-select">
        <ng-option *ngFor="let type of timesForSecondSelector" [value]="type">{{type}}</ng-option>
      </ng-select>
    </div>
  </div>
</div>